import { render, staticRenderFns } from "./PaywayErorrButton.vue?vue&type=template&id=c87b2db6"
import script from "./PaywayErorrButton.vue?vue&type=script&lang=js"
export * from "./PaywayErorrButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports